import { FieldType, FieldVisibility } from "./forms.js";
export const AGENT_REQUEST_TYPE_LABELS = {
    HIERARCHY_CHANGE: "Change Hierarchy",
    TERMINATE_CONTRACT: "Terminate Contract",
    COMMISSION_INCREASE: "Commission Increase",
    INTELELEAD_INVITE: "Send Intelelead Invite",
    INSURANCE_TOOLKIT_ADD_AGENT: "Add Insurance Toolkit Agent",
};
/** Created by automation / staff ops — not offered as an agent self-serve request type. */
export const SYSTEM_ONLY_AGENT_REQUEST_TYPES = [
    "INTELELEAD_INVITE",
    "INSURANCE_TOOLKIT_ADD_AGENT",
];
const effectiveDateField = {
    id: "effectiveDate",
    name: "effectiveDate",
    label: "Requested Effective Date",
    type: FieldType.DATE,
    required: true,
    visibility: FieldVisibility.ALWAYS,
};
const reasonField = {
    id: "reason",
    name: "reason",
    label: "Reason",
    type: FieldType.TEXTAREA,
    required: true,
    placeholder: "Explain why this change is needed...",
    visibility: FieldVisibility.ALWAYS,
};
export const AGENT_REQUEST_SECTIONS = {
    HIERARCHY_CHANGE: {
        id: "hierarchy_change",
        title: "Change Hierarchy Request",
        description: "Request a change to your direct upline.",
        fields: [
            {
                id: "newUplineName",
                name: "newUplineName",
                label: "New Direct Upline",
                type: FieldType.TEXT,
                required: true,
                placeholder: "Upline name",
                visibility: FieldVisibility.ALWAYS,
            },
            effectiveDateField,
            reasonField,
        ],
    },
    TERMINATE_CONTRACT: {
        id: "terminate_contract",
        title: "Terminate Contract Request",
        description: "Request termination of a carrier contract.",
        fields: [
            {
                id: "carrier",
                name: "carrier",
                label: "Carrier",
                type: FieldType.TEXT,
                required: true,
                placeholder: "Carrier name",
                visibility: FieldVisibility.ALWAYS,
            },
            effectiveDateField,
            reasonField,
        ],
    },
    COMMISSION_INCREASE: {
        id: "commission_increase",
        title: "Commission Increase Request",
        description: "Request a commission level increase.",
        fields: [
            {
                id: "carrier",
                name: "carrier",
                label: "Carrier",
                type: FieldType.TEXT,
                required: true,
                placeholder: "Carrier name",
                visibility: FieldVisibility.ALWAYS,
            },
            {
                id: "requestedLevel",
                name: "requestedLevel",
                label: "Requested Commission Level",
                type: FieldType.TEXT,
                required: true,
                placeholder: "e.g. 90.00%",
                visibility: FieldVisibility.ALWAYS,
            },
            reasonField,
        ],
    },
    INTELELEAD_INVITE: {
        id: "intelelead_invite",
        title: "Send Intelelead Invite",
        description: "Manual follow-up when Dialer Intelelead invite automation could not complete.",
        fields: [
            {
                id: "agentEmail",
                name: "agentEmail",
                label: "Agent Email",
                type: FieldType.EMAIL,
                required: true,
                visibility: FieldVisibility.ALWAYS,
            },
            {
                id: "uplineName",
                name: "uplineName",
                label: "Altura Upline",
                type: FieldType.TEXT,
                required: false,
                visibility: FieldVisibility.ALWAYS,
            },
            {
                id: "failureReason",
                name: "failureReason",
                label: "Automation Failure",
                type: FieldType.TEXTAREA,
                required: true,
                visibility: FieldVisibility.ALWAYS,
            },
        ],
    },
    INSURANCE_TOOLKIT_ADD_AGENT: {
        id: "insurance_toolkit_add_agent",
        title: "Add Insurance Toolkit Agent",
        description: "Manual follow-up when Insurance Toolkit add-agent automation could not complete.",
        fields: [
            {
                id: "agentEmail",
                name: "agentEmail",
                label: "Agent Email",
                type: FieldType.EMAIL,
                required: true,
                visibility: FieldVisibility.ALWAYS,
            },
            {
                id: "failureReason",
                name: "failureReason",
                label: "Automation Failure",
                type: FieldType.TEXTAREA,
                required: true,
                visibility: FieldVisibility.ALWAYS,
            },
        ],
    },
};
